// extracted by mini-css-extract-plugin
export default {"section5":"Section5_section5__DX34h"};